export const licenseKey =
  "ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjkxMGNmOWI2LWI3OGItNGM3MC1hZmRjLTVmODg5YzljM2M3NiIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjMyCn0=.UGKS4zl+YFFGhc2JVv+jk7aglNW5EjrskgCtGsNWWqkRhgXHY1tcy5+euUNaehzo5pfXTzEYbjxG1Iex4P25ueWWxB/GR/ikquGLAuN2vhge+TUUypLdwNBxT48DICni+TaLPg==";
